import React from 'react';
import {EmailOrPhoneLocation, space, UpdateBusinessProfileRequest} from "../../../../provider_api";
import '../../../App.css';
import {ServiceTypes} from "../../../../util/ServiceTypes";
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";
import {EditableStringField} from "../../../../components/Editable/EditableStringField";
import {EditableLongTextField} from "../../../../components/Editable/EditableLongTextField";
import {EditableMultiSelect} from "../../../../components/Editable/EditableMultiSelect";
import {EditablePhotoUpload} from "../../../../components/Editable/EditablePhotoUpload";
import {useProviderProfile} from "../../../../ProviderProfileProvider";
import {KensuProfileEditor} from "../../../../components/table/KensuProfileEditor";
import {EditableVerifiedPhoneInputField} from "../../../../components/Editable/EditableVerifiedPhoneInputField";
import {EditableVerifiedEmailField} from "../../../../components/Editable/EditableVerifiedEmailField";
import IBusinessProfileProto = space.kenko.proto.IBusinessProfileProto;
import BusinessProfileProto = space.kenko.proto.BusinessProfileProto;
import {getMouseEventProps} from "@testing-library/user-event/dist/keyboard/getEventProps";
import {useProfileTabs} from "./ProfileRouter";

/**
 * This is different from other things being KensuObjectEditor
 * cause it's a singleton.
 *
 * @constructor
 */
export const BusinessProfile = () => {

  const {businessProfile} = useProviderProfile();
  const profileTabs = useProfileTabs()

  if (!businessProfile) {
    return 'Error loading profile'
  }

  return <>

    <div style={{flex: 0}}>
      <TabbedPageHeader pageTitle={'Business Profile'} tabs={profileTabs}/>
    </div>

    <KensuProfileEditor<IBusinessProfileProto>
        idParam={'singleton'} // this is a singleton, doesn't make sense.
        entityName={'Business Profile'}
        hideHeaderInEditMode={true}
        entityListViewLink={'../profile'}
        getFromProfile={profile => profile.proto}
        getTitle={profile => ''}
        newBlankType={() => new BusinessProfileProto()}
        getRpcMethod={_ => 'update_business_profile'}
        getRpcPayload={business => {
          return UpdateBusinessProfileRequest.encode(
              new UpdateBusinessProfileRequest({
                businessProfile: business
              })).finish();
        }}>

      <EditableStringField<IBusinessProfileProto>
          label={'Business name'}
          field={'businessName'}
          inputType={'text'}/>

      <EditableLongTextField<IBusinessProfileProto>
          label={'About your business'}
          field={'businessDescription'}
      />

      <EditableMultiSelect<IBusinessProfileProto, string>
          label={'Service categories'}
          field={'servicesOffered'}
          options={ServiceTypes}
      />

      <EditableVerifiedPhoneInputField<IBusinessProfileProto>
          label={'Primary business phone number'}
          location={EmailOrPhoneLocation.BUSINESS}
          field={'phoneNumber'}
          errorKey={'phone'}
      />


      <EditableVerifiedEmailField<IBusinessProfileProto>
          label={'Primary business email'}
          location={EmailOrPhoneLocation.BUSINESS}
          field={'email'}
          errorKey={'email'}
      />

      <EditableStringField<IBusinessProfileProto>
          label={'Business website (optional)'}
          field={'websiteUrl'}
          inputType={'text'}
      />

      <EditablePhotoUpload<IBusinessProfileProto>
          label={'Business Logo'}
          field={"imageUrl"}
          helpText={editing => editing ? 'Please upload a jpg, png, or gif up to 5MB' : undefined}
      />
    </KensuProfileEditor>
  </>
}